import {ContextBarOptionGroup, ContextBarOptionTypes} from '@q9elements/ui-kit/components';
import {BaseContextBar} from '../base-context-bar';
import {StickerColorPickerComponent} from './components/sticker-color-picker.component';
import {Injectable} from '@angular/core';
import {menuItems} from '../../context-menu/menu-items';
import {SelectionTypes} from 'src/app/shared/models/diagram-interactions.interface';

@Injectable()
export class StickerContextBar extends BaseContextBar {
  public selectionType = SelectionTypes.Sticker;

  public getOptions(): ContextBarOptionGroup[] | null {
    const stickerJson = this.selectedCell.getJson();

    switch (true) {
      case this.isSelected.one: {
        return [
          [
            {
              type: ContextBarOptionTypes.COMPONENT,
              component: StickerColorPickerComponent,
              inputs: {stickerJson},
              tooltip: 'CONTEXT_BAR.FILL_COLOR',
              q9Track: 'CONTEXT_TOOLBAR.STICKER.FILL_COLOR'
            }
          ],
          [
            this.createMenuItemOption(menuItems.font),
            this.createMenuItemOption(menuItems.tags),
            this.createMenuItemOption(menuItems.theme)
          ],
          [this.createMenuItemOption(menuItems.copy), this.createMenuItemOption(menuItems.delete)]
        ];
      }

      default:
        return null;
    }
  }
}
